import React from 'react';
import Data from '../../../json/text.json';
import axios from 'axios';
import { motion } from 'framer-motion';

class Texts extends React.Component {
  constructor(props) {
    super(props);
    let slugArray = props.slug.split('/');
    let addClass = props.class ? props.class : '';
    let addText = props.addText ? props.addText : '';
    let getClass = Data[slugArray[0]] ? Data[slugArray[0]][slugArray[1]] : '';
    let getText = Data[slugArray[0]] ? Data[slugArray[0]][slugArray[1]] : [];
    let text = '';
    if(Data[slugArray[0]]) {
      if(Data[slugArray[0]][slugArray[1]]) {
        text = Data[slugArray[0]][slugArray[1]].text;
        text = text ? text : 'テキストが設定されていません。';
      } else {
        text = 'テキストが設定されていません。';
      }
    } else {
      text = 'グループが設定されていません。';
    }
    let textClass = getClass ? 'c-text__'+ getClass.type : ' c-text__normal c-text--error c-text--bold';
    this.state = {
      data: Data,
      group: slugArray[0],
      slug: slugArray[1],
      class: addClass ?  addClass + ' ' + textClass : textClass,
      text: addText ? addText : text,
      res: '',
      animation: props.animation,
    }
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    // axios
    //   .get(tmp_path.site_url+"/wp-json/wp/v2/custom/texts/?id="+this.state.group+"_"+this.state.slug)
    //   .then(response => {
    //     let getText = response.data[0].text;
    //     if(getText) {
    //       this.setState({
    //         text: getText,
    //       });
    //     }
    //   })
    //   .catch(error => console.log(error));
  }

  render() {
    if(this.state.animation == 'scrollUp') {
      let textArray = [...this.state.text];
      let strArray = [];
      textArray.map((value, index) =>
        strArray.push(
          <motion.div
            key={`firstview${index}`}
            variants={{
              offscreen: { // 画面外の場合のスタイル
                y: 20,
                opacity: 0,
              },
              onscreen: { // 画面内の場合のスタイル
                y: 0,
                opacity: 1,
                transition: {
                  duration: 0.3,
                  delay: .05 * index,
                  ease: "easeInOut",
                },
              },
            }}
            initial="offscreen" // 初期表示はoffscreen
            whileInView="onscreen" // 画面内に入ったらonscreen
            viewport={{ once: true, amount: 0 }}
          >
            <span key={index}>{value}</span>
          </motion.div>
        )
      );
      return(
        <>
          <div
            className={this.state.class}
          >
            { strArray }
          </div>
        </>
      )
    } else {
      return(
        <p
          id={this.state.group + '_' + this.state.slug}
          className={this.state.class}
          dangerouslySetInnerHTML={{ __html: this.state.text }}
        />
      )
    }
  }
}

export default Texts;
